import React from "react";

export default function Spinner({ text = "Loading...", style = {} }) {
  return (
    <div
      style={{
        minHeight: "40vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        ...style,
      }}
    >
      <div
        style={{
          width: 40,
          height: 40,
          borderRadius: 0,
          border: "3px solid #FFD600",
          borderTop: "3px solid #eee",
          animation: "spin 1s linear infinite",
        }}
      />
      <div style={{ color: "#232b35", fontWeight: 600, fontSize: 16, marginTop: 18 }}>
        {text}
      </div>
      <style>
        {`
          @keyframes spin {
            100% { transform: rotate(360deg);}
          }
        `}
      </style>
    </div>
  );
}